import {
  CLIENT_CHOICE,
  CLIENT_META,
} from '@/features/ChoicesLists/Simple/choiceCategories/client';
import { COMPANY_CHOICE } from '@/features/ChoicesLists/Simple/choiceCategories/company';
import {
  GENERAL_CHOICE,
  GENERAL_META,
} from '@/features/ChoicesLists/Simple/choiceCategories/general';
import {
  HAU_CHOICE,
  HAU_META,
} from '@/features/ChoicesLists/Simple/choiceCategories/hau';
import { HUN_CHOICE } from '@/features/ChoicesLists/Simple/choiceCategories/hun';
import {
  KFZ_CHOICE,
  KFZ_META,
  KFZ_V2_CHOICE,
} from '@/features/ChoicesLists/Simple/choiceCategories/kfz';
import { PHV_CHOICE } from '@/features/ChoicesLists/Simple/choiceCategories/phv';
import {
  RES_CHOICE,
  RES_META,
} from '@/features/ChoicesLists/Simple/choiceCategories/res';
import {
  PKV_CHOICE,
  PKV_META,
} from '@/features/ChoicesLists/Simple/choiceCategories/pkv';
import {
  WOH_CHOICE,
  WOH_META,
} from '@/features/ChoicesLists/Simple/choiceCategories/woh';
import {
  UNF_CHOICE,
  UNF_META,
} from '@/features/ChoicesLists/Simple/choiceCategories/unf';
import {
  BU_CHOICE,
  BU_META,
} from '@/features/ChoicesLists/Simple/choiceCategories/bu';
import { RLV_CHOICE } from '@/features/ChoicesLists/Simple/choiceCategories/rlv';
import { Sparte } from '@/features/Global/types';
import { getChoiceValues } from '@/features/ChoicesLists/Simple/utils';

export const SIMPLE_CHOICE = {
  ...CLIENT_CHOICE,
  ...GENERAL_CHOICE,
  ...COMPANY_CHOICE,

  // Sparten specific choices
  ...KFZ_CHOICE,
  ...KFZ_V2_CHOICE,
  ...RES_CHOICE,
  ...PHV_CHOICE,
  ...HUN_CHOICE,
  ...HAU_CHOICE,
  ...WOH_CHOICE,
  ...UNF_CHOICE,
  ...PKV_CHOICE,
  ...BU_CHOICE,
  ...RLV_CHOICE,
};

export type SimpleChoiceKey = keyof typeof SIMPLE_CHOICE;
export type SimpleChoiceType = (typeof SIMPLE_CHOICE)[SimpleChoiceKey];

export interface SimpleChoiceOption {
  value: string;
  label: string;
}

export interface SimpleChoiceGrouped {
  label: string;
  items: SimpleChoiceOption[];
}

export interface SimpleChoiceOptionGesellschaftenTs extends SimpleChoiceOption {
  insuranceId: number;
}

export interface SimpleChoice {
  default: string;
  meta: Record<string, string | string[] | Record<string, string[]>>;
  name: string;
  values: SimpleChoiceOption[];
}

export const SIMPLE_CHOICE_META = {
  ...CLIENT_META,
  ...GENERAL_META,

  // Sparten specific meta
  ...KFZ_META,
  ...RES_META,
  ...HAU_META,
  ...WOH_META,
  ...UNF_META,
  ...PKV_META,
  ...BU_META,
};

export type SimpleChoiceMetaKey = keyof typeof SIMPLE_CHOICE_META;
export type SimpleChoiceMetaType =
  (typeof SIMPLE_CHOICE_META)[SimpleChoiceMetaKey];

export const GlobalChoices: SimpleChoiceType[] = [
  ...getChoiceValues(GENERAL_CHOICE),
  ...getChoiceValues(COMPANY_CHOICE),
  ...getChoiceValues(CLIENT_CHOICE),
];

export const SpartenSpecificChoices: {
  [key in Sparte]?: SimpleChoiceType[];
} = {
  hun: [...getChoiceValues(HUN_CHOICE)],
  pkw: [...getChoiceValues(KFZ_CHOICE)],
  pkwv2: [...getChoiceValues(KFZ_CHOICE), ...getChoiceValues(KFZ_V2_CHOICE)],
  unf: [...getChoiceValues(UNF_CHOICE)],
  res: [...getChoiceValues(RES_CHOICE)],
  phv: [...getChoiceValues(PHV_CHOICE)],
  nutz: [...getChoiceValues(KFZ_CHOICE)],
  nutzv2: [...getChoiceValues(KFZ_CHOICE), ...getChoiceValues(KFZ_V2_CHOICE)],
  hau: [...getChoiceValues(HAU_CHOICE)],
  camp: [...getChoiceValues(KFZ_CHOICE)],
  campv2: [...getChoiceValues(KFZ_CHOICE), ...getChoiceValues(KFZ_V2_CHOICE)],
  krad: [...getChoiceValues(KFZ_CHOICE)],
  kradv2: [...getChoiceValues(KFZ_CHOICE), ...getChoiceValues(KFZ_V2_CHOICE)],
  woh: [...getChoiceValues(WOH_CHOICE)],
  pkv: [...getChoiceValues(PKV_CHOICE)],
  bu: [...getChoiceValues(BU_CHOICE)],
  rlv: [...getChoiceValues(RLV_CHOICE)],
};
